module.exports = __webpack_public_path__ + "img/photo-5.2ec602c1.jpg";